import React, { useState, useRef, useEffect, Fragment } from "react";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import "./App.css";
import { SwitchTransition, CSSTransition } from "react-transition-group";
import { reviewsArr } from "./data";
import JobPaper from "./JobPaper";
import { SuccessIndicator } from "./JobPaper";
import { serviceArr } from "./data.js";
import QuoteModal from "./QuoteModal";
import driveway5 from "./Photos/TuffHammerPhotos/driveway5.jpg";
import driveway4 from "./Photos/TuffHammerPhotos/driveway4.jpg";
import driveway2 from "./Photos/TuffHammerPhotos/driveway2.jpg";
import ArrowForwardIcon from "@material-ui/icons/ArrowRightAlt";
import contactorginal from "./Photos/TuffHammerPhotos/contactorginal.jpg";
import SVGPICK from "./SVGPICK";
import backgroundImagePhoto from "./Photos/TuffHammerPhotos/backgroundImagePhoto.jpg";
import Vectors from "./Vectors";
import { useHistory } from "react-router-dom";
import {
  Grid,
  Button,
  Paper,
  Fade,
  Slide,
  makeStyles,
  Card,
  Collapse,
  Grow,
  TextField,
  useMediaQuery,
  Hidden,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";

import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
//import { Facebook, Instagram } from "@material-ui/icons";
const textColorDark = "black";
const textColorLight = "white";
const backgroundColorDark = "rgba(215,215,215,0)"; //"#E8183A";
const paperPadding = 32;

const HomeScreen = ({ setOutline }) => {
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };
    setOutline({ home: true });
    //  scrollToTop();
  }, []);

  ///////////Form submission functions////////////////////////////////////////////////////

  const encode = (data) => {
    return Object.keys(data)
      .map(
        (key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
      )
      .join("&");
  };
  function handleSubmit(e) {
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "contact", name: "John" }),
    })
      .then(() => alert("Success!"))
      .catch((error) => alert(error));

    e.preventDefault();
  }
  /////////////////////////////////////////////////////////////////////////////////////////
  const [inViewServices, setInViewServices] = useState(false); //controls transition in
  const [inViewProjects, setInViewProjects] = useState(false);
  const [inViewReviews, setInViewReviews] = useState(false);
  const [inViewContactUs, setInViewContactUs] = useState(false);
  const [quoteModalVisible, setQuoteModalVisible] = useState(false);

  const contactUsRef = useRef();
  const servicesRef = useRef();
  const projectsRef = useRef();
  const reviewsRef = useRef();
  //services
  useScrollPosition(({ prevPos, currPos }) => {
    const postiveCurrPosy = Math.abs(currPos.y); //turns number postive, scroll postion is negative number
    const { offsetTop } = servicesRef.current; //where the element ends with respect to viewport(bottom of element)
    const topOfEl = offsetTop - postiveCurrPosy - 200; //this is how to get top of element (the 100 is optional but makes whatever you want happen 100px earlier )
    // console.log(servicesRef.current.getBoundingClientRect()); //this gives the top position of the element with respect to current scroll postion.
    if (postiveCurrPosy >= topOfEl) {
      setInViewServices(true); //set to to true to see transition
    }
  });
  //projects
  useScrollPosition(({ prevPos, currPos }) => {
    const postiveCurrPosy = Math.abs(currPos.y); //turns number postive, scroll postion is negative number
    const { offsetTop } = projectsRef.current; //where the element ends with respect to viewport(bottom of element)
    const topOfEl = offsetTop - postiveCurrPosy; //this is how to get top of element (the 100 is optional but makes whatever you want happen 100px earlier )
    //  console.log({ offsetTop, postiveCurrPosy, topOfEl });

    if (postiveCurrPosy >= topOfEl) {
      setInViewProjects(true); //set to to true to see transition
    }
  });
  //reviews
  useScrollPosition(({ prevPos, currPos }) => {
    const postiveCurrPosy = Math.abs(currPos.y); //turns number postive, scroll postion is negative number
    const { offsetTop } = reviewsRef.current; //where the element ends with respect to viewport(bottom of element)
    const topOfEl = offsetTop - postiveCurrPosy + 800; //this is how to get top of element (the 100 is optional but makes whatever you want happen 100px earlier )
    if (postiveCurrPosy >= topOfEl) {
      setInViewReviews(true); //set to to true to see transition
    }
  });
  //contacts
  useScrollPosition(({ prevPos, currPos }) => {
    const postiveCurrPosy = Math.abs(currPos.y); //turns number postive, scroll postion is negative number
    const { offsetTop } = contactUsRef.current; //where the element ends with respect to viewport(bottom of element)
    const topOfEl = Math.abs(offsetTop - postiveCurrPosy) + 1300; //this is how to get top of element (the 100 is optional but makes whatever you want happen 100px earlier )
    //console.log({ offsetTop, postiveCurrPosy, topOfEl });
    if (postiveCurrPosy >= topOfEl) {
      setInViewContactUs(true); //set to to true to see transition
    }
  });

  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down("md"), {
    defaultMatches: true,
  });

  const fadeTimeout = {
    appear: 0,
    enter: 300,
  };
  const slideTimeout = {
    appear: 1000,
    enter: 1300,
  };

  const slideTimeoutTwo = {
    appear: 1200,
    enter: 1500,
  };

  return (
    <Grid
      container
      style={{ backgroundColor: "rgba(245,245,245,1)", position: "relative" }}
    >
      <div
        style={{
          position: "absolute",
          backgroundColor: "rgba(0,0,0,.5)",
          zIndex: 3,
          width: "100%",
          height: "100%",
          display: quoteModalVisible ? "block" : "none",
        }}
      ></div>

      <Grid
        item //TOp COntainer
        container
        xs={12}
        style={{ height: 770 }}
      >
        <Grid
          item
          container
          xs={12}
          style={{ height: 670, position: "relative" }}
        >
          <Grid
            item
            container
            xs={12}
            style={{
              //     backgroundImage: `url(${backgroundImagePhoto})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              height: "100%",
              width: "100%",
              position: "relative",
            }}
          >
            <Grid
              item
              container
              xs={12}
              style={{
                // backgroundColor: "rgba(5,5,0,1)",
                //backgroundImage on small Screen, it's own image pn md screens
                backgroundImage: smallScreen
                  ? `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${backgroundImagePhoto})`
                  : null,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                //  padding: 24,
                height: "100%",
              }}
              justifyContent="space-between"
            >
              <Grid
                item
                container
                xs={smallScreen ? 12 : 5}
                alignItems="center"
              >
                <Grid item style={{ padding: 24 }}>
                  <h1
                    style={{
                      color: smallScreen ? "white" : "black",
                      fontSize: 48,
                      lineHeight: 1.2,
                    }}
                  >
                    Bringing Projects <br></br>to Life
                  </h1>
                  <p
                    style={{
                      color: smallScreen
                        ? "rgba(200,200,200,1)"
                        : "rgba(5,5,0,1)",
                      marginTop: 24,
                    }}
                  >
                    We are a construction company that specializes in concrete
                    driveways, steps, sidewalks, basement floors, excavation and
                    etc. We look forward to making your dream project come to
                    life.
                  </p>
                  <Paper
                    style={{
                      backgroundColor: "#BD0027",
                      padding: 16,
                      height: 50,
                      width: 140,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      marginTop: 40,
                      borderRadius: 40,
                    }}
                    elevation={6}
                    onClick={() => setQuoteModalVisible(true)}
                  >
                    <p className="cta-text">Get a Quote</p>
                  </Paper>
                  <QuoteModal
                    quoteModalVisible={quoteModalVisible}
                    setQuoteModalVisible={setQuoteModalVisible}
                  />
                </Grid>
              </Grid>
              <Hidden mdDown>
                <Grid item container xs={12} md={6} justifyContent="center">
                  <Grid item container xs={12}>
                    <img
                      src={backgroundImagePhoto}
                      alt="me"
                      style={{
                        width: "100%",
                        height: "100%",
                        // borderRadius: 5,
                        zIndex: 100,
                        filter: "brightness(80%)",
                      }}
                    />
                  </Grid>
                </Grid>
              </Hidden>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Fade
        in={inViewServices}
        timeout={fadeTimeout}
        easing={{ enter: "cubic-bezier(0.37, 0.36, 0.67, 1.01)" }}
      >
        <Grid
          container //services
          item
          xs={12}
          style={{ height: "100%", marginTop: 0 }}
          ref={servicesRef}
          spacing={2}
        >
          <Grid item container xs={12} md={6} style={{}}>
            <Grid item md={10} style={{ paddingLeft: 24 }}>
              <h1
                style={{
                  color: "#151515",
                  fontSize: 48,
                  textAlign: smallScreen ? "center" : "left",
                }}
              >
                Services
              </h1>

              <p
                style={{
                  fontSize: 20,
                  color: "rgba(5,5,0,1)",
                  marginTop: 24,
                  // fontWeight: "bold",
                }}
              >
                Concrete workers in the commercial construction industry provide
                a wide variety of services. These services include turnkey
                projects, new construction, interior fit-outs, site improvements
                and renovations.
              </p>
            </Grid>
            <Grid
              item //services map
              container
              xs={12}
              alignItems="center"
              style={{ marginTop: smallScreen ? 16 : 0 }}
              // direction="column"
            >
              <Grid
                item
                container
                xs={12}
                spacing={1}
                // direction="column"
                style={{
                  height: smallScreen ? "100%" : "100%",
                  paddingLeft: 24,
                }}
              >
                {serviceArr.map((item, index) => {
                  return (
                    <Grid item sm={6} xs={12}>
                      <Paper
                        className="nav-btns"
                        style={{
                          height: 60,
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: 16,
                        }}
                      >
                        <p style={{ width: "50%" }}>{item.title}</p>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            height: "100%",
                            width: "50%",
                          }}
                        >
                          <img
                            src={item.icon}
                            alt={item.title}
                            height="100%"
                            width="100%"
                          />
                        </div>
                      </Paper>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          </Grid>
          <Grid item container xs={12} md={6} justifyContent="center">
            <SVGPICK height={"100%"} width="100%" />
          </Grid>
          <Grid
            item
            container
            xs={12}
            md={5}
            // alignItems="center"
            style={{ padding: 24 }}
          ></Grid>
        </Grid>
      </Fade>
      <Fade
        in={inViewProjects}
        timeout={slideTimeout}
        direction="left"
        //  easing={{ enter: "cubic-bezier(0.37, 0.36, 0.67, 1.01)" }}
      >
        <Grid //Projects
          item
          container
          xs={12}
          justifyContent="center"
          alignItems="center"
          style={{
            backgroundColor: backgroundColorDark,
            height: "100%",
            //  paddingTop: 80,
            marginTop: 64,
          }}
          ref={projectsRef}
        >
          <Hidden mdUp>
            <DualPics smallScreen={smallScreen} />
          </Hidden>
          <Hidden smDown>
            <DualPicsTwo smallScreen={smallScreen} />
          </Hidden>
        </Grid>
      </Fade>
      <Fade
        in={inViewReviews}
        timeout={slideTimeoutTwo}
        direction="right"
        //  easing={{ enter: "cubic-bezier(0.37, 0.36, 0.67, 1.01)" }}
      >
        <Grid
          item //Reviews Container
          container
          xs={12}
          style={{
            height: "100%",
            position: "relative",
          }}
          ref={reviewsRef}
        >
          <Grid // absolute div not in use can delete
            item
            container
            xs={12}
            justifyContent="center"
            style={{
              position: "absolute",
              height: "100%",
            }}
          >
            <Grid
              item
              container
              xs={6}
              style={{
                backgroundColor: backgroundColorDark,
                height: "100%",
              }}
            ></Grid>
          </Grid>
          <Grid
            item
            container
            //justifyContent={smallScreen ? "center" : null}
            xs={12}
            style={{
              marginBottom: 32,
              marginTop: 56,
              zIndex: 5,
              paddingLeft: 16,
            }}
          >
            <h1
              style={{
                color: "#151515",
                fontSize: 48,
                textAlign: smallScreen ? "center" : "left",
              }}
            >
              Our Customers Said
            </h1>
          </Grid>
          <Grid //reviews
            item
            container
            xs={12}
            md={12}
            justifyContent="center"
            style={{ zIndex: 5 }}
          >
            <Hidden mdUp>
              <SmallScreenReviews smallScreen={smallScreen} />
            </Hidden>
            <Hidden smDown>
              <Reviews smallScreen={smallScreen} />
            </Hidden>
          </Grid>
        </Grid>
      </Fade>
      <Grid
        container
        item
        xs={12} //Contact Container
        style={{
          position: "relative",
          height: "100%",
          //marginBottom: 24,
          marginTop: 64,
        }}
        ref={contactUsRef}
      >
        <Grid
          container
          item
          xs={12}
          md={7}
          style={{ maxHeight: 600, position: "relative" }}
          justifyContent="center"
        >
          <Grid
            item
            container
            xs={12}
            alignItems="center"
            justifyContent="center"
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0,0,0,.2)",
            }}
          >
            <Paper
              style={{
                padding: 16,
                borderRadius: 20,
                minWidth: 200,
              }}
              elevation={10}
            >
              <h1
                style={{
                  textAlign: "center",
                  color: "#151515",
                }}
              >
                Contact Us
              </h1>
            </Paper>
          </Grid>
          <img
            src={contactorginal}
            className="dualpics"
            alt="ill"
            style={{ width: "100%", height: "100%" }}
          />
        </Grid>
        <Grid xs={12} md={5}>
          <Contacts
            inViewContactUs={inViewContactUs}
            smallScreen={smallScreen}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

const Reviews = ({ flex, smallScreen }) => {
  const [reviews, setReviews] = useState([...reviewsArr]);
  const [reviewNum, setReviewNum] = useState(0);
  //  console.log(reviews[reviewNum]);

  function randomNum() {
    if (reviewNum + 1 === reviews.length) {
      setReviewNum(0);
      return;
    }
    console.log(reviews[reviewNum].project);
    setReviewNum(reviewNum + 1);
  }
  return (
    <Grid container item xs={12} md={12} direction="row">
      <Grid
        item
        container
        xs={12}
        //  alignItems="center"
        justifyContent="center"
        direction="row"
        style={{}}
        spacing={2}
      >
        <Grid item xs={5}>
          <Paper
            elevation={4}
            style={{
              padding: paperPadding,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <p
              style={{
                color: "rgba(100,100,100,1)",
                textAlign: "left",
                //   textIndent: "-.5em",
              }}
            >
              {reviews[reviewNum].review}
            </p>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 16,
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p className="subtext"> {reviews[reviewNum].name}</p>
                <h4> {reviews[reviewNum].project}</h4>
              </div>
            </div>
          </Paper>
        </Grid>
        <Grid
          item //2nd review
          xs={3}
        >
          <Paper
            elevation={4}
            style={{
              padding: paperPadding,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <p
              style={{
                color: "rgba(100,100,100,1)",
                textAlign: "left",
                //   textIndent: "-.5em",
              }}
            >
              {reviews[1].review}
            </p>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 16,
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p className="subtext"> {reviews[1].name}</p>
                <h4> {reviews[1].project}</h4>
              </div>
            </div>
          </Paper>
        </Grid>
        <Grid item xs={3}>
          <Paper
            elevation={4}
            style={{
              padding: paperPadding,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <p
              style={{
                color: "rgba(100,100,100,1)",
                textAlign: "left",
              }}
            >
              {reviews[2].review}
            </p>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 16,
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p className="subtext"> {reviews[2].name}</p>
                <h4> {reviews[2].project}</h4>
              </div>
            </div>
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  );
};

const SmallScreenReviews = ({ smallScreen }) => {
  const [reviews, setReviews] = useState([...reviewsArr]);
  const [reviewNum, setReviewNum] = useState(0);
  //  console.log(reviews[reviewNum]);

  function randomNum() {
    if (reviewNum + 1 === reviews.length) {
      setReviewNum(0);
      return;
    }
    console.log(reviews[reviewNum].project);
    setReviewNum(reviewNum + 1);
  }
  return (
    <Grid
      container
      item
      xs={12}
      md={12}
      direction="row"
      style={
        {
          //  padding: 16,
          //  backgroundColor: "#BD0027",
          //   height: 500,
          //  flex: isDefined(flex, flex, 1),
        }
      }
    >
      <Grid
        item
        container
        xs={12}
        //  alignItems="center"
        justifyContent="center"
        style={{}}
      >
        <Grid item xs={10}>
          <Paper
            elevation={4}
            style={{
              padding: paperPadding,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <SwitchTransition mode="out-in">
              <CSSTransition
                classNames="review"
                key={reviews[reviewNum].review}
                //this is needed if timeout not provided. If timeout provided I beleive it will run the timeouts instead of the css
                addEndListener={(node, done) => {
                  node.addEventListener("transitionend", done, false);
                }}
              >
                <p
                  style={{
                    color: "rgba(100,100,100,1)",
                    textAlign: "left",
                    //   textIndent: "-.5em",
                  }}
                >
                  {reviews[reviewNum].review}
                </p>
              </CSSTransition>
            </SwitchTransition>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 16,
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p className="subtext"> {reviews[reviewNum].name}</p>
                <h4> {reviews[reviewNum].project}</h4>
              </div>
              <div style={{ marginLeft: 48 }}>
                <div
                  style={{
                    borderRadius: 50,
                    height: 50,
                    width: 50,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    //flexDirection: "column",
                    alignSelf: "flex-end",
                    cursor: "pointer",
                  }}
                  onClick={randomNum}
                >
                  <p className="subtext">next</p>
                  <SvgRightBtn color="#E8183A" />
                </div>
              </div>
            </div>
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  );
};
const Contacts = ({ inViewContactUs, smallScreen }) => {
  useEffect(() => {
    setContactCard({ question: true });
    return () => {
      console.log("leaving");
    };
  }, []);
  const [contactCard, setContactCard] = useState({
    question: true,
    job: false,
  });

  return (
    <Grid item container style={{ height: "100%" }}>
      <Grid
        item
        container
        xs={12}
        alignItems="space-between"
        // justifyContent="center"
        //  wrap="wrap"
        style={{ padding: 16, height: "85%" }}
      >
        <Grid
          item
          container
          xs={12}
          justifyContent="center"
          style={{ marginTop: smallScreen ? 16 : null }}
        >
          <Grid item container xs={12} justifyContent="space-evenly">
            <Grid
              item
              xs={smallScreen ? 5 : 4}
              onClick={() => setContactCard({ question: true })}
            >
              <p className="contact-btns">Ask A question</p>
            </Grid>
            <Grid item xs={4} onClick={() => setContactCard({ job: true })}>
              <p className="contact-btns">Apply for Job</p>
            </Grid>
          </Grid>
          <ContactBox
            inViewContactUs={inViewContactUs}
            contactCard={contactCard}
            smallScreen={smallScreen}
          />
        </Grid>
      </Grid>
      <Grid
        item
        container
        xs={12}
        alignItems="center"
        style={{
          backgroundColor: "rgba(230,230,230,0)",
          paddingLeft: 16,
          paddingRight: 16,
        }}
      >
        <Grid
          item
          container
          xs={6}
          direction="column"
          justifyContent="flex-end"
          alignItems="center"
        >
          <p className="subtext" style={{ marginBottom: 0 }}>
            tuff.hammerllc@gmail.com
          </p>
          <p className="subtext">(816)-679-8456</p>
        </Grid>
        <Grid item container xs={6} justifyContent="center" alignItems="center">
          <Insta />
          <Facebook />
        </Grid>
      </Grid>
    </Grid>
  );
};

const ContactBox = ({ inViewContactUs, contactCard, smallScreen }) => {
  const [dataSent, setDataSent] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "None Required",
    message: "",
  });

  ///////////Form submission functions////////////////////////////////////////////////////

  const encode = (data) => {
    return Object.keys(data)
      .map(
        (key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
      )
      .join("&");
  };
  function handleSubmit(e) {
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "contact", ...formData }),
    })
      .then(() => console.log("Success"))
      .catch((error) => alert(error));

    e.preventDefault();
  }
  /////////////////////////////////////////////////////////////////////////////////////////

  function updateFormData(e) {
    // console.log(formData);
    // console.log(e.target.name + "what looking at");
    const field = e.target.name; //get the fileds name so it can be udated in the state(makes it dynamic)
    setFormData((prev) => {
      return {
        ...prev,
        [field]: e.target.value,
      };
    });
  }

  //submitting data, when dataSent true, different component displays.

  function submitData(e) {
    if (dataSent) return; //so they can't keep pushing the div to send data
    setDataSent(true);
    handleSubmit(e);
    setTimeout(() => {
      setDataSent(false);
    }, 2000);
  }

  const contactFadeTimeout = {
    appear: 1000,
    enter: 1300,
  };

  return (
    <Grid
      item
      container
      xs={10}
      direction="column"
      justifyContent="space-between"
      style={{ marginTop: 16 }}
    >
      <Fade in={inViewContactUs} timeout={contactFadeTimeout}>
        {contactCard.job ? (
          <JobPaper smallScreen={smallScreen} />
        ) : (
          <Paper
            style={{
              display: "flex",
              flexDirection: "column",
              padding: paperPadding,
            }}
          >
            <TextField
              label="Name"
              name="name"
              variant="filled"
              onChange={updateFormData}
            />
            <TextField
              label="Phone"
              name="phone"
              variant="filled"
              onChange={updateFormData}
            />
            <TextField
              label="Ask Something..."
              name="message"
              variant="outlined"
              multiline={true}
              rows={3}
              style={{ marginTop: 24 }}
              onChange={updateFormData}
            />
            <Grid
              item
              container
              justifyContent="flex-end"
              style={{ marginTop: 32 }}
            >
              <div
                style={{
                  borderRadius: 50,
                  height: 50,
                  width: dataSent ? "100%" : 100,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  //flexDirection: "column",
                  alignSelf: "flex-end",
                  cursor: "pointer",
                }}
                onClick={submitData}
              >
                {dataSent ? (
                  <SuccessIndicator />
                ) : (
                  <Fragment style={{}}>
                    <p className="subtext">Send</p>
                    <SvgRightBtn color="#E8183A" />
                  </Fragment>
                )}
              </div>
            </Grid>
          </Paper>
        )}
      </Fade>
    </Grid>
  );
};

const DualPicsTwo = ({ smallScreen }) => {
  const history = useHistory();
  function goToPage(page) {
    history.push(page);
  }
  return (
    <Grid item container xs={12} spacing={0}>
      <Grid item container xs={12}>
        <Grid item container xs={6} style={{ height: 400 }}>
          <img
            src={driveway4}
            style={{
              height: "100%",
              width: "100%",
              //  opacity: 0.6,
              //    borderRadius: 5,
            }}
            alt="me"
            className="dualpics"
          />
        </Grid>
        <Grid
          item
          container
          xs={6}
          style={{}}
          alignItems="flex-start"
          justifyContent="center"
        >
          <Grid item container xs={10} style={{}}>
            <h1
              style={{
                fontSize: 48,
                // textAlign: "center",
                color: "#151515",
              }}
            >
              Projects
            </h1>

            <p
              style={{
                fontSize: 20,
                color: "rgba(5,5,0,1)",
                marginTop: 16,
                textAlign: "left",
                // fontWeight: "bold",
              }}
            >
              We only provide the best to our customers and our projects always
              leave you satisfied and the neighbors in awe!
            </p>
            <Paper
              style={{
                backgroundColor: "#BD0027",
                padding: 16,
                height: 50,
                width: 140,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                marginTop: 24,
                borderRadius: 40,
              }}
              elevation={6}
              onClick={() => goToPage("/projects")}
            >
              <p className="cta-text" style={{ marginRight: 8 }}>
                See All
              </p>
              <SvgRightBtn width={40} height={50} />
            </Paper>
          </Grid>
        </Grid>
      </Grid>
      <Grid item container xs={12} justifyContent="center">
        <Grid item container xs={8} style={{ height: 400 }}>
          <img
            src={driveway2}
            className="dualpics"
            style={{
              height: "100%",
              width: "100%",
              //   borderRadius: 5,
              marginTop: "-10%",
            }}
            alt="me"
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
const DualPics = ({ smallScreen }) => {
  const history = useHistory();
  function goToPage(page) {
    history.push(page);
  }
  return (
    <Grid
      item
      container
      xs={12}
      md={8}
      justifyContent="center"
      wrap="nowrap"
      style={{
        height: "90%",
        position: "relative",
        padding: smallScreen ? 16 : null,
      }}
    >
      <Grid item container xs={12} md={7} style={{}}>
        <img
          src={driveway2}
          style={{
            height: "100%",
            width: "100%",
            opacity: 0.6,
            borderRadius: 5,
          }}
          alt="me"
          className="dualpics"
        />
      </Grid>
      <Grid item container xs={12} md={6} style={{ zIndex: 3 }}>
        {" "}
        <img
          src={driveway4}
          className="dualpics"
          style={{
            height: "100%",
            width: smallScreen ? "100%" : "130%",
            marginLeft: smallScreen ? 0 : -100,
            marginTop: 20,
            borderRadius: 5,
          }}
          alt="me"
        />
      </Grid>
      <div
        style={{
          display: "flex",
          position: "absolute",
          top: "50%",
          zIndex: 4,
          cursor: "pointer",
          alignItems: "center",
        }}
        onClick={() => {
          goToPage("/projects");
        }}
      >
        <h1 style={{ color: "black" }}>See Projects</h1>
        <SvgRightBtnAnim />
      </div>
    </Grid>
  );
};

const SvgRightBtnAnim = () => {
  return (
    <svg
      width="54"
      height="54"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="animated-arrow"
    >
      <path
        d="M18.17 13L15.59 15.59L17 17L22 12L17 7L15.59 8.41L18.17 11H2V13H18.17Z"
        fill="#E8183A"
      />
    </svg>
  );
};

const SvgRightBtn = ({ height, width, color }) => {
  return (
    <svg
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.17 13L15.59 15.59L17 17L22 12L17 7L15.59 8.41L18.17 11H2V13H18.17Z"
        fill={color ? color : "white"}
      />
    </svg>
  );
};

const Facebook = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="social-icons"
      onClick={() => window.open("https://www.facebook.com/Tuffhammer")}
    >
      <path
        d="M2.00195 12.002C2.00312 16.9214 5.58036 21.1101 10.439 21.881V14.892H7.90195V12.002H10.442V9.80204C10.3284 8.75958 10.6845 7.72064 11.4136 6.96698C12.1427 6.21332 13.1693 5.82306 14.215 5.90204C14.9655 5.91417 15.7141 5.98101 16.455 6.10205V8.56104H15.191C14.7558 8.50405 14.3183 8.64777 14.0017 8.95171C13.6851 9.25566 13.5237 9.68693 13.563 10.124V12.002H16.334L15.891 14.893H13.563V21.881C18.8174 21.0506 22.502 16.2518 21.9475 10.9611C21.3929 5.67041 16.7932 1.73997 11.4808 2.01722C6.16831 2.29447 2.0028 6.68235 2.00195 12.002Z"
        fill="#2E3A59"
      />
    </svg>
  );
};

const Insta = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="social-icons"
      onClick={() => window.open("https://www.instagram.com/tuff_hammer/")}
    >
      <path
        d="M12.002 21.041C9.54195 21.041 9.25195 21.028 8.29195 20.986C7.54332 20.9614 6.80439 20.8092 6.10695 20.536C4.90026 20.0664 3.94609 19.1119 3.47695 17.905C3.21426 17.205 3.07257 16.4655 3.05795 15.718C3.00195 14.76 3.00195 14.446 3.00195 12.005C3.00195 9.538 3.01495 9.25 3.05795 8.295C3.07289 7.54853 3.21457 6.81001 3.47695 6.111C3.94558 4.90253 4.9013 3.94718 6.10995 3.479C6.8086 3.21521 7.5473 3.07315 8.29395 3.059C9.24895 3.005 9.56295 3.005 12.002 3.005C14.482 3.005 14.767 3.018 15.712 3.059C16.4605 3.07327 17.2012 3.21531 17.902 3.479C19.1103 3.94771 20.0658 4.90288 20.535 6.111C20.8021 6.8202 20.9445 7.57026 20.956 8.328C21.012 9.28601 21.012 9.59901 21.012 12.039C21.012 14.479 20.998 14.799 20.956 15.746C20.9411 16.4942 20.799 17.2344 20.536 17.935C20.0656 19.1427 19.11 20.0976 17.902 20.567C17.2022 20.8292 16.4631 20.9709 15.716 20.986C14.761 21.041 14.448 21.041 12.002 21.041ZM11.968 4.588C9.52195 4.588 9.26795 4.6 8.31295 4.643C7.74294 4.65056 7.17843 4.75575 6.64395 4.954C5.85471 5.25601 5.23018 5.878 4.92495 6.666C4.72517 7.2063 4.61996 7.77698 4.61395 8.353C4.56095 9.322 4.56095 9.576 4.56095 12.005C4.56095 14.405 4.56995 14.696 4.61395 15.659C4.62291 16.2292 4.72805 16.7938 4.92495 17.329C5.23063 18.1165 5.85505 18.738 6.64395 19.04C7.17807 19.2396 7.7428 19.3448 8.31295 19.351C9.28095 19.407 9.53595 19.407 11.968 19.407C14.421 19.407 14.675 19.395 15.622 19.351C16.1924 19.3441 16.7573 19.2389 17.292 19.04C18.0764 18.7354 18.6969 18.1153 19.002 17.331C19.2014 16.7903 19.3065 16.2193 19.313 15.643H19.324C19.367 14.687 19.367 14.432 19.367 11.989C19.367 9.54601 19.356 9.289 19.313 8.334C19.304 7.76446 19.1988 7.20052 19.002 6.666C18.6976 5.88058 18.077 5.2593 17.292 4.954C16.7574 4.75475 16.1924 4.64953 15.622 4.643C14.655 4.588 14.402 4.588 11.968 4.588ZM12.002 16.624C10.1319 16.6252 8.44537 15.4997 7.72882 13.7725C7.01226 12.0452 7.40686 10.0563 8.72858 8.73347C10.0503 7.4106 12.0388 7.01428 13.7667 7.72934C15.4946 8.4444 16.6215 10.13 16.622 12C16.6192 14.5511 14.553 16.619 12.002 16.624ZM12.002 8.998C10.3451 8.998 9.00195 10.3412 9.00195 11.998C9.00195 13.6549 10.3451 14.998 12.002 14.998C13.6588 14.998 15.002 13.6549 15.002 11.998C14.9981 10.3427 13.6572 9.00185 12.002 8.998ZM16.802 8.28501C16.2074 8.2828 15.7269 7.79959 15.728 7.20501C15.7291 6.61043 16.2114 6.12901 16.806 6.12901C17.4005 6.12901 17.8828 6.61042 17.884 7.205C17.8842 7.49187 17.7702 7.76703 17.5672 7.96968C17.3642 8.17234 17.0888 8.2858 16.802 8.28501Z"
        fill="#2E3A59"
      />
    </svg>
  );
};
export default HomeScreen;
